import { render, staticRenderFns } from "./addCustomerService.vue?vue&type=template&id=51fa48ba&scoped=true&"
import script from "./addCustomerService.vue?vue&type=script&lang=js&"
export * from "./addCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fa48ba",
  null
  
)

export default component.exports